import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Actions
import { actions as abActions } from 'modules/ab/actions'

// Components
import { StreamField } from 'components/staticpages/streamfield'

// Types
import type { CmsBlock, State } from 'types'

export type ABTestBlockProps = {
  value: {
    experiment_id: string
    active: boolean
    variants: Array<Array<CmsBlock>>
  }
}

const ABTestBlock = ({ value: { active, variants, experiment_id } }: ABTestBlockProps) => {
  const dispatch = useDispatch()
  const selectedVariantId = useSelector<State, number>(state => state.ab[experiment_id])
  useEffect(() => {
    if (active) {
      dispatch(abActions.registerExperiment(experiment_id, variants.length))
    }
  }, []) // eslint-disable-line

  if (!variants || variants.length === 0) {
    return null
  }

  const selectedVariant = variants[!active ? 0 : selectedVariantId]
  return <StreamField blocks={selectedVariant} />
}

export default ABTestBlock
